'use client';

import { useCallback } from 'react';
import { useAuthenticatedSWR } from '../api';
import { MX_PLAN_TYPES_BASE_URL } from './constants';

export const useMxPlanCombos = ({
  subscriptionId,
  mealPlanId,
  cadence = '',
  defaultCadence = '',
  ignoreCohort = false,
}) => {
  const cadenceParam = cadence || defaultCadence;

  const params = new URLSearchParams({
    ...(ignoreCohort && {
      ignore_cohort: 'true',
    }),
    ...(cadenceParam && {
      cadence: cadenceParam,
    }),
  });

  const allRequiredParamsAvailable = !!subscriptionId && !!mealPlanId;
  const hasQueryParams = cadenceParam || ignoreCohort;

  const { data, error, isValidating, mutate } = useAuthenticatedSWR(
    allRequiredParamsAvailable &&
      `${MX_PLAN_TYPES_BASE_URL}${subscriptionId}/plans/${mealPlanId}/${
        hasQueryParams ? `?${params.toString()}` : ''
      }`,
  );

  const revalidate = useCallback(() => mutate(), [mutate]);

  return {
    isLoading: allRequiredParamsAvailable ? !data && !error : false,
    data,
    error,
    isValidating,
    revalidate,
  };
};
